<template lang="pug">
  v-progress-linear(:active="showTopLoading" indeterminate=true absolute bottom color="cyan accent-4")
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: mapGetters(['showTopLoading'])
}
</script>
